export const getTableColumns = (tableColumnsKeys, headerIntl) =>
  Object.values(tableColumnsKeys).map(columnKey => ({
    key: columnKey,
    header: `${headerIntl}.${columnKey}`,
    greaterFunc: (a, b) => !b || a > b,
    lowerFunc: (a, b) => !a || a < b
  }));
